import {
  DownloadBannerType,
  DownloadBannerStatus,
  DOWNLOAD_BANNER_TYPE,
  DOWNLOAD_BANNER_STATUS,
} from 'models/Download';

export const DOWNLOAD_BANNER_TITLE_COPY: Record<
  DownloadBannerType,
  Record<DownloadBannerStatus, string>
> = {
  [DOWNLOAD_BANNER_TYPE.FILE]: {
    [DOWNLOAD_BANNER_STATUS.PREPARING]: 'preparingFilesForDownload',
    [DOWNLOAD_BANNER_STATUS.SUCCESS]: 'downloadInitiated',
    [DOWNLOAD_BANNER_STATUS.ERROR]:
      'thereWasAnErrorWhilePreparingYourDownloading',
  },
  [DOWNLOAD_BANNER_TYPE.REPORT]: {
    [DOWNLOAD_BANNER_STATUS.PREPARING]: 'reportExportInProgressTitle',
    [DOWNLOAD_BANNER_STATUS.SUCCESS]: 'reportDownloadInitiated',
    [DOWNLOAD_BANNER_STATUS.ERROR]:
      'thereWasAnErrorWhilePreparingYourReportDownload',
  },
  [DOWNLOAD_BANNER_TYPE.ANALYTICS]: {
    [DOWNLOAD_BANNER_STATUS.PREPARING]: 'exportStarted',
    [DOWNLOAD_BANNER_STATUS.SUCCESS]: 'exportDownloading',
    [DOWNLOAD_BANNER_STATUS.ERROR]: 'thereWasAnErrorWhilePreparingYourExport',
  },
  [DOWNLOAD_BANNER_TYPE.LEAD_ANALYTICS]: {
    [DOWNLOAD_BANNER_STATUS.PREPARING]: 'exportStarted',
    [DOWNLOAD_BANNER_STATUS.SUCCESS]: 'exportDownloading',
    [DOWNLOAD_BANNER_STATUS.ERROR]: 'thereWasAnErrorWhilePreparingYourExport',
  },
  [DOWNLOAD_BANNER_TYPE.BOSS_MODE]: {
    [DOWNLOAD_BANNER_STATUS.PREPARING]: 'exportStarted',
    [DOWNLOAD_BANNER_STATUS.SUCCESS]: 'exportDownloading',
    [DOWNLOAD_BANNER_STATUS.ERROR]: 'thereWasAnErrorWhilePreparingYourExport',
  },
  [DOWNLOAD_BANNER_TYPE.RFI_CATEGORIES]: {
    [DOWNLOAD_BANNER_STATUS.PREPARING]: 'preparingFilesForDownload',
    [DOWNLOAD_BANNER_STATUS.SUCCESS]: 'downloadInitiated',
    [DOWNLOAD_BANNER_STATUS.ERROR]: 'thereWasAnErrorWhilePreparingYourExport',
  },
  [DOWNLOAD_BANNER_TYPE.ENTERPRISE_USAGE_REPORT]: {
    [DOWNLOAD_BANNER_STATUS.PREPARING]: 'preparingFilesForDownload',
    [DOWNLOAD_BANNER_STATUS.SUCCESS]: 'downloadInitiated',
    [DOWNLOAD_BANNER_STATUS.ERROR]: 'reportCouldNotBeGenerated',
  },
};
